import { render, staticRenderFns } from "./UnreadChats.vue?vue&type=template&id=c2b8db0c&scoped=true&"
import script from "./UnreadChats.vue?vue&type=script&lang=js&"
export * from "./UnreadChats.vue?vue&type=script&lang=js&"
import style0 from "./UnreadChats.vue?vue&type=style&index=0&id=c2b8db0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b8db0c",
  null
  
)

export default component.exports